import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type {
  CompleteSupportRequestMutation,
  CompleteSupportRequestMutationVariables,
} from '@/shared/api';
import COMPLETE_SUPPORT_REQUEST from '../mutations/completeSupportRequest';

/**
 * Completes a support request from the public completion link. Runs the COMPLETE_SUPPORT_REQUEST mutation on a client created without an auth token, since the link is opened by an unauthenticated recipient, and unwraps completeSupportRequest through the shared error handler.
 *
 * @param variables - Mutation variables identifying the support request to complete.
 * @returns Promise resolving to the completion payload.
 */
const handleCompleteSupportRequest = async (
  variables: CompleteSupportRequestMutationVariables,
): Promise<CompleteSupportRequestMutation['completeSupportRequest']> => {
  const client = createClient({ isUsingToken: false });
  const result = await client.mutate<
    CompleteSupportRequestMutation,
    CompleteSupportRequestMutationVariables
  >({
    mutation: COMPLETE_SUPPORT_REQUEST,
    variables,
  });
  return handleErrorApi(result, 'completeSupportRequest');
};

export default handleCompleteSupportRequest;
